// src/Models/permissionModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class PermissionModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      permissionID: data.permissionID || data.permissionId,
      roleID: data.roleID || data.roleId,
      permissionKey: data.permissionKey,
      permissionValue: data.permissionValue !== undefined ? data.permissionValue : false,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      permissionId: Number(data.permissionID || data.permissionId || 0),
      roleId: Number(data.roleID || data.roleId || 0),
      permissionKey: data.permissionKey || '',
      permissionValue: data.permissionValue === true || data.permissionValue === 'true',
    };
  }
}
